module.exports = __webpack_public_path__ + "static/media/UploadPlaceHolder.f8cdb17c.png";